import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Upload,
  LineChart,
  ShieldAlert,
  Truck,
  Layers,
  SlidersHorizontal,
} from "lucide-react";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "sidebar-nav-dashboard", end: true },
  { to: "/import", label: "Import Data", icon: Upload, testid: "sidebar-nav-import" },
  { to: "/forecast", label: "Forecast Engine", icon: LineChart, testid: "sidebar-nav-forecast" },
  { to: "/risk", label: "Inventory Risk", icon: ShieldAlert, testid: "sidebar-nav-risk" },
  { to: "/suppliers", label: "Supplier Insights", icon: Truck, testid: "sidebar-nav-suppliers" },
  { to: "/rationalization", label: "SKU Rationalization", icon: Layers, testid: "sidebar-nav-rationalization" },
  { to: "/settings", label: "Settings", icon: SlidersHorizontal, testid: "sidebar-nav-settings" },
];

export default function Sidebar() {
  return (
    <aside
      data-testid="sidebar"
      className="fixed inset-y-0 left-0 w-64 bg-slate-950 border-r border-slate-800 flex flex-col z-30"
    >
      <div className="h-16 flex items-center px-6 border-b border-slate-800">
        <div className="flex items-center gap-2.5">
          <div className="h-8 w-8 rounded-md bg-white flex items-center justify-center">
            <span className="font-heading font-bold text-slate-950 text-sm tracking-tight">Av</span>
          </div>
          <div>
            <div className="font-heading font-bold text-white text-[15px] tracking-tight leading-none">Avyntis</div>
            <div className="text-[10px] uppercase tracking-[0.12em] text-slate-500 mt-1">MRO Analytics</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-0.5 overflow-y-auto">
        {NAV.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({ isActive }) =>
              `group flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
                isActive
                  ? "bg-slate-800 text-white"
                  : "text-slate-400 hover:text-slate-100 hover:bg-slate-900"
              }`
            }
          >
            <Icon className="h-4 w-4 shrink-0" strokeWidth={2} />
            <span className="truncate">{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-4 py-4 border-t border-slate-800">
        <div className="text-[11px] text-slate-500 leading-relaxed">
          Avyntis is an analytics platform.
          <span className="text-slate-400"> We do not sell, supply, or hold MRO inventory.</span>
        </div>
      </div>
    </aside>
  );
}
